import React from "react";

/**
 * Iter 48 — Top-level ErrorBoundary.
 * Catches render crashes, shows a themed-pink "Lost the plot" card
 * (matches 404 vibe), one white pill button to reload.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, info: null };
  }
  static getDerivedStateFromError(err) {
    return { hasError: true, info: err?.message || String(err) };
  }
  componentDidCatch(error, errorInfo) {
    // Keep console clean of raw React red walls — one concise line
    try { console.warn("[ErrorBoundary]", error?.message || error, errorInfo?.componentStack?.split("\n")?.[1]); } catch {}
  }
  reset = () => { this.setState({ hasError: false, info: null }); window.location.reload(); };
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen themed-pink sticker-wall flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full text-center relative z-10">
          <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-white/80 mb-2">● Something broke</div>
          <h1 className="font-fancy uppercase text-white leading-[0.9]" style={{ fontSize: "clamp(44px, 8vw, 88px)", textShadow: "3px 3px 0 rgba(0,0,0,0.3)" }}>
            Lost the <span className="text-striped">plot.</span>
          </h1>
          <p className="mt-5 text-white/90 text-base">
            A page just went off-script. Nothing's lost — one reload usually fixes it.
          </p>
          <button
            onClick={this.reset}
            data-testid="error-boundary-reload"
            className="btn-pill-white mt-7"
          >
            Reload the page →
          </button>
          {process.env.NODE_ENV !== "production" && this.state.info && (
            <div className="mt-6 text-[10px] font-mono text-white/60 bg-black/30 p-3 rounded-xl text-left whitespace-pre-wrap break-words">
              {this.state.info}
            </div>
          )}
        </div>
      </div>
    );
  }
}
